import React, {useMemo, useContext} from 'react'
import { Redirect } from 'react-router-dom'
import {TeacherContext} from 'teacher/context'
import './monitoring.styl'
import views from 'components/monitoring'

export default function Monitoring() {
  const context = useContext(TeacherContext)
  const {section, link} = context
  const Element = useMemo(() => views[section], [section])
  return Element
    ? <div className={`${section}-container`}><Element /></div>
    : <Redirect to={link({section: 'groups'})} />
}
